import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-xref-api-key-modal',
  templateUrl: './xref-api-key-modal.component.pug',
  styleUrls: ['./xref-api-key-modal.component.scss'],
  standalone: false
})
export class XrefApiKeyModalComponent implements OnInit {
  @Input() xrefApiKey = '';
  @Input() keyExist = false;
  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() saveClick: EventEmitter<any> = new EventEmitter();
  acceptedAgreement = false;
  isChanged = false;
  acknowledgementMessage = $localize`I acknowledge and agree that Xref will generate and use the API key to communicate with Xref applications in order to facilitate reference requests. Further information can be found in the Xref Terms and Conditions and Privacy Policy.`

  constructor(
    private permissions: PermissionsService,
    public bsModalRef: BsModalRef,) {}

  ngOnInit(): void { }

  delete(){
    this.deleteClick.emit();
    this.bsModalRef.hide();
  }
  save(){
    this.saveClick.emit({'xrefApiKey':this.xrefApiKey});
    this.bsModalRef.hide();
  }
  cancel(){
    this.bsModalRef.hide();
  }
}
